import { CommonMainPage } from '../../widgets/utility/CommonMainPage'
import React from 'react'
import { EditAccountForm } from './widgets/edit-account-form/EditAccountForm'
import { useGetProfileInfoQuery } from '../../app/api'
import { ChangeEmailForm } from './widgets/change-email-form/ChangeEmailForm'
import { ChangePasswordForm } from './widgets/change-password-form/ChangePasswordlForm'
import { useTranslation } from 'react-i18next'
import { LinkedEmails } from './widgets/linked-emails/LinkedEmails'
import clsx from 'clsx'

import styles from './ProfileSettingsPage.module.scss'
import { useMenuLayout } from '../../app/layouts/main-layout/hooks/UseMenuLayout'

export const ProfileSettingsPage = () => {
  const { t } = useTranslation()
  const { menuLayout } = useMenuLayout()
  const { data: profileInfo } = useGetProfileInfoQuery()

  return (
    <CommonMainPage title={t('navigation.profileSettings')}>
      {menuLayout === 'top' && (
        <h2 className={clsx(styles.title)}>{t('pages.profile.profileSettings')}</h2>
      )}
      <section className={clsx(styles.section)}>
        {profileInfo?.data && (
          <EditAccountForm className={clsx(styles.formCard)} data={profileInfo.data} />
        )}
        <ChangeEmailForm className={clsx(styles.formCard)} />
        <ChangePasswordForm className={clsx(styles.formCard)} />
        <LinkedEmails className={clsx(styles.formCard)} />
      </section>
    </CommonMainPage>
  )
}
